/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: EmbeddedServicePage
 * Page name: embedded-services
 * Page Description: This is the embedded-services page of the website of Ekathva Innovations, it consists of all the
 * details about embedded services provided by the company.
*/

import React,{ Component } from 'react'

import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags'
import { Card, Button, Image, Col, Row, Media, Modal} from "react-bootstrap"
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import Navbar from "components/Navbars/Navbar";
import LandingPageEmbedded from 'components/Headers/LandingPageEmbedded'
import Footer from 'components/Footers/Footer'

import { Formik, Form } from 'formik';
import { Input } from 'reactstrap';
import Validation from '../Validation.js';
import ApiService from '../api/ApiService.js';

import 'assets/style/Style.css'
import successImage from 'assets/images/AllPage/list.png';
import failureImage from 'assets/images/AllPage/into.png';

import {ReactComponent as Plus} from "assets/images/AllPage/Plus.svg"

import {ReactComponent as ED1} from "assets/images/EmbeddedService/ED1.svg"
import {ReactComponent as ED2} from "assets/images/EmbeddedService/ED2.svg"
import {ReactComponent as ED3} from "assets/images/EmbeddedService/ED3.svg"
import {ReactComponent as ED4} from "assets/images/EmbeddedService/ED4.svg"
import {ReactComponent as ED5} from "assets/images/EmbeddedService/ED6.svg"
import {ReactComponent as ED6} from "assets/images/EmbeddedService/ED5.svg"
import {ReactComponent as ED7} from "assets/images/EmbeddedService/ED7.svg"

//Mobile View
import TechM1 from "assets/images/EmbeddedService/TechM1.jpg"
import TechM2 from "assets/images/EmbeddedService/TechM2.jpg"
//Success Stories
import FingerPrinting from "assets/images/EmbeddedService/FPU.png"
import OilBlending from "assets/images/EmbeddedService/OilBlending.jpg"
import TimeLogger from "assets/images/EmbeddedService/TimeLogger.jpg"
import WirelessMotor from "assets/images/EmbeddedService/WirelessMotor.jpg"
import PST from "assets/images/EmbeddedService/PST.png"

import EmbeddedTechnologies from "views/EmbeddedTechnologies"

const responsive = {
  superLargeDesktop: {

    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

class EmbeddedServicePage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      modal_project: false,
      modal_success: false,
      modal_failure: false,
      name: "",
      projectTitle: "",
      emailAddress: "",
      contactNumber: "",
      organizationName: "",
      city: "",
      requirement: "",
              }

    this.onProjectSubmit = this.onProjectSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.toggle = this.toggle.bind(this);
  };

  componentDidMount() {
    // this is needed, because InfiniteCalendar forces window scroll
    window.scrollTo(0, 0);
  }


    toggle = modalType => () => {
      console.log("inside toggle");
      if (!modalType) { return this.setState({ modal: !this.state.modal }); }
      this.setState({ [`modal_${modalType}`]: !this.state[`modal_${modalType}`] });
    };

    handleChange(event) {
      const target = event.target;
      const name = target.name;
      let value = event.target.value
      this.setState({ [name]: value});
    }

    onKeyPressTextOnly(event) {
      if(event.charCode !== 32){ Validation.onKeyPressTextOnly(event); }
    }
    onKeyPressNumberOnly(event){
      if(event.charCode !== 32){ Validation.onKeyPressNumberOnly(event);  }
    }
    onKeyPressRetrisctSomeSC(event){
    if(event.charCode !== 32){ Validation.onKeyPressRetrisctSomeSC(event);  }
  }

  camelCaseString(string){

    let words = string.trim().split(" ");

    let result = "";

    for(let i=0; i < words.length; i++){
      if(words[i] !== ""){
        result = result + " " +words[i][0].toUpperCase() + words[i].substring(1).toLowerCase();
      }
    }

    return result;

  }

  onProjectSubmit(values) {

    console.log(values);

      let fields = {
        name: this.camelCaseString(values.name),
        projectTitle: this.camelCaseString(values.projectTitle),
        emailAddress: values.emailAddress,
        contactNumber: values.contactNumber,
        organizationName: this.camelCaseString(values.organizationName),
        city: this.camelCaseString(values.city),
        requirement: values.requirement
      }


      ApiService.createProject(fields)
      .then((response) =>{
        this.setState({
          modal_project: !this.state.modal_project,
          modal_success: !this.state.modal_success,
          message: "We have received your Requirement! We will get back to you soon."
        })
      }).catch((error) =>{
        this.setState({
          modal_project: !this.state.modal_project,
          modal_failure: !this.state.modal_failure,
          message: "Something Went Wrong! Please Try Again"
        })
      })
    }

    render() {
      let {name, projectTitle, emailAddress, contactNumber, organizationName, city, requirement} = this.state
      return (
        <div>
            <MetaTags>
                <title>Embedded System, IoT, PCB designing in Shivamogga | Ekathva Innovations Pvt Ltd</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
            </MetaTags>

            <Navbar/>
            <LandingPageEmbedded/>
            <br/>
            <div>
                <div  className='homepage_spacing'>
                    <div>
                        <div>
                            <Row>
                                <Col md={6}>
                                    <br/>
                                    <p data-aos="fade-right">
                                        <strong>
                                            The Embedded team at Ekathva Innovations has the expertise to design and develop products.
                                            Our team can identify the need, design, and build the solutions from scratch to suit the
                                            specific requirement of the customer. We provide the best services from basics circuit
                                            design to product level designing including prototype development with a well-versed
                                            engineering team.
                                        </strong>
                                    </p>
                                    <p data-aos="fade-right">
                                        <strong>
                                            In the two years journey, we have already served more than 15+ clients with our expertise
                                            in embedded systems, IoT and PCB designs
                                        </strong>
                                    </p>
                                    <br/><br/>

                                    <h5>
                                        <span className='aboutus_fontbold'>Technologies </span>we work with <Link to="/Technologies">
                                        <Plus class="rounded mx-auto homepage_plussize" />
                                        </Link>

                                        </h5>
                                    <div data-aos="zoom-in" className='embedded_listdisplay1'>
                                        <EmbeddedTechnologies />
                                    </div>

                                    <div className='it_techspacing1'>
                                    <Link to='/technologies'>
                                    <Carousel
                                    autoPlay={true}
                                    responsive={responsive}
                                    infinite={true}
                                    autoPlaySpeed={2500}>
                                        <Row>
                                            <div>
                                                <img src={'https://drive.google.com/uc?export=view&id=1wYVliJ5Va_da8jyvzN28GSYgus1Rd5oS'} className='it_techimage'/>
                                            </div>
                                        </Row>
                                        <Row>
                                            <div>
                                                <img src={'https://drive.google.com/uc?export=view&id=1dDpd5J13Tk8snNkprtYCBYA7ZNofXFPv'} className='it_techimage'/>
                                            </div>
                                        </Row>
                                    </Carousel>
                                </Link>
                            </div>
                                </Col>

                                <Col  className='embedded_rowspacing'  xs={5}>
                                    <div>
                                        <Row>
                                            <Col>
                                                <div className='embedded_colspacing' >
                                                    <Media  data-aos="fade-left" >
                                                        <ED1 className="align-self-start mr-3 embedded_logo svgcolor"/>
                                                        <Media.Body>
                                                            <p>
                                                                <strong>Digtal / Analog Circuit Design</strong>
                                                            </p>
                                                        </Media.Body>
                                                    </Media>
                                                    <br/>

                                                    <Media  data-aos="fade-left" >
                                                        <ED2 className="align-self-start mr-3 embedded_logo svgcolor" />
                                                        <Media.Body>
                                                            <p >
                                                                <strong>Embedded System Design</strong>
                                                            </p>
                                                        </Media.Body>
                                                    </Media>
                                                    <br/>

                                                    <Media  data-aos="fade-left" >
                                                        <ED3 className="align-self-start mr-3 embedded_logo svgcolor"/>
                                                        <Media.Body>
                                                            <p >
                                                                <strong>Wireless System Design [IoT]</strong>
                                                            </p>
                                                        </Media.Body>
                                                    </Media>
                                                    <br/>

                                                    <Media  data-aos="fade-left" >
                                                        <ED4 className="align-self-start mr-3 embedded_logo svgcolor"/>
                                                        <Media.Body>
                                                            <p>
                                                                <strong>Prototyping and Development Service</strong>
                                                            </p>
                                                        </Media.Body>
                                                    </Media>
                                                    <br/>

                                                    <Media  data-aos="fade-left" >
                                                        <ED5 className="align-self-start mr-3 embedded_logo svgcolor"/>
                                                        <Media.Body>
                                                            <p>
                                                                <strong>Embedded Cloud Computing Service </strong>
                                                            </p>
                                                        </Media.Body>
                                                    </Media>
                                                    <br/>

                                                    <Media  data-aos="fade-left" >
                                                        <ED6 className="align-self-start mr-3 embedded_logo svgcolor" />
                                                        <Media.Body>
                                                            <p>
                                                                <strong>Single-Sided PCB Design</strong>
                                                            </p>
                                                        </Media.Body>
                                                    </Media>
                                                    <br/>

                                                    <Media  data-aos="fade-left" >
                                                        <ED7 className="align-self-start mr-3 embedded_logo svgcolor" />
                                                        <Media.Body>
                                                            <p >
                                                                <strong>Double-Sided PCB Design</strong>
                                                            </p>
                                                        </Media.Body>
                                                    </Media>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <br/>

                                <div className='embedded_listspacing' >
                                    <ul>
                                        <li><p className='aboutus_fontbold'>Digital/ Analog Circuit Design</p></li>
                                        <li><p className='aboutus_fontbold'>Embedded System Design</p></li>
                                        <li><p className='aboutus_fontbold'>Wireless System Design [IOT]</p></li>
                                        <li><p className='aboutus_fontbold'>Prototyping and Development Service</p></li>
                                        <li><p className='aboutus_fontbold'>Embedded Cloud Computing Service [IOT]</p></li>
                                        <li><p className='aboutus_fontbold'>Single-Sided PCB Design</p></li>
                                        <li><p className='aboutus_fontbold'>Double-Sided PCB Design</p></li>
                                    </ul>
                                </div>
                            </Row>
                        </div>
                    </div>
                    <hr/>
                </div>
                <br/>

                <div className='aboutus_mainspace'>
                    <Row>
                        <Col>
                            <Card>
                                <div className='embedded_projectspacing'>
                                    <h4> <span className='aboutus_fontbold' >Let's Work</span> Together</h4>
                                    <p>
                                        <strong>
                                            If you have an idea/requirement and you feel we can serve you, please let us know.
                                        </strong>
                                    </p>
                                    <div className='it_buttonalign'>

                                        <Link onClick={this.toggle('project')} class="cta" style={{ textDecoration: 'none' }}>
                                        <span>Start a Project</span>
                                        <svg width="13px" height="10px" viewBox="0 0 13 10">
                                        <path d="M1,5 L11,5"></path>
                                        <polyline points="8 1 12 5 8 9"></polyline>
                                        </svg>
                                        </Link>
                                    </div>
                                    <Modal show={this.state.modal_project} backdrop='static' size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered>
                                    <Modal.Header closeButton onClick={this.toggle('project')}>
                                    <Modal.Title>
                                    Start a Project
                                    </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                    <Formik
                                    onSubmit={this.onProjectSubmit}
                                    initialValues={{name, projectTitle, emailAddress, contactNumber, organizationName, city, requirement}}
                                    validateOnChange={false}
                                    validateOnBlur={false}
                                    enableReinitialize={true}
                                    onChange={this.handleChange}>

                                    <Form>

                                    <Row>
                                    <Col md={2}>
                                    <label>Project Title<span className="register_page_marker">*</span></label>
                                    </Col>
                                    <Col md={4}>
                                    <Input  className="capitalize"
                                    name="projectTitle" type="text"
                                    onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                                    onChange={this.handleChange}
                                    placeholder="Enter Project Title"
                                    minLength="2" maxLength="200" required />
                                    </Col>
                                    <Col md={2}>
                                    <label>Name<span className="register_page_marker">*</span></label>
                                    </Col>
                                    <Col md={4}>
                                    <Input  className="capitalize"
                                    name="name" type="text"
                                    onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                                    onChange={this.handleChange}
                                    placeholder="Enter Your Name"
                                    minLength="2" maxLength="200" required />
                                    </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                    <Col md={2}>
                                    <label>Contact Number<span className="register_page_marker">*</span></label>
                                    </Col>
                                    <Col md={4} className="text-center">
                                    <Input
                                    name="contactNumber" type="text"
                                    minLength="10" maxLength="10"
                                    placeholder="Enter Your Contact Number"
                                    onChange={this.handleChange}
                                    onKeyPress={event => {this.onKeyPressNumberOnly(event)}}
                                    required />
                                    </Col>
                                    <Col md={2} >
                                    <label>Email Address<span className="register_page_marker">*</span></label>
                                    </Col>
                                    <Col md={4} className="text-center">
                                    <Input
                                    name="emailAddress" type="email"
                                    onChange={this.handleChange}
                                    placeholder="Enter Your Email"
                                    onKeyPress={event => {this.onKeyPressRetrisctSomeSC(event)}}
                                    maxLength="200" minLength="10" required />
                                    </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                    <Col md={2}>
                                    <label>Organization Name<span className="register_page_marker">*</span></label>
                                    </Col>
                                    <Col md={4}>
                                    <Input  className="capitalize"
                                    name="organizationName" type="text"
                                    onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                                    onChange={this.handleChange}
                                    placeholder="Enter Your  Organization Name"
                                    minLength="2" maxLength="200" required />
                                    </Col>
                                    <Col md={2}>
                                    <label>City<span className="register_page_marker">*</span></label>
                                    </Col>
                                    <Col md={4}>
                                    <Input  className="capitalize"
                                    name="city" type="text"
                                    onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                                    onChange={this.handleChange}
                                    placeholder="Enter Your City Name"
                                    minLength="2" maxLength="200" required />
                                    </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                    <Col md={10} >
                                    <label>Requirement<span className="register_page_marker">*</span></label>
                                    </Col>
                                    </Row>
                                    <Row>
                                    <Col md={12} className="text-center">
                                    <Input placeholder="Enter Your Requirement" name="requirement"
                                    maxLength="200"
                                    type="textarea" rows="2" onChange={this.handleChange}
                                    onKeyPress={event => {this.onKeyPressRetrisctSomeSC(event)}}
                                    required />
                                    </Col>
                                    </Row>

                                    <Row>

                                    <Col  md={2} >
                                    <Button variant="outline-danger" type="submit">Submit</Button>
                                    </Col>
                                    <Col  md={2} >
                                    <Button variant="outline-secondary" type="button" onClick={this.toggle('project')}>Cancel</Button>
                                    </Col>
                                    </Row>

                                    </Form>
                                    </Formik>
                                    </Modal.Body>
                                    </Modal>

                                </div>
                            </Card>
                        </Col>

                        <Col>
                            <Card>
                                <div className='embedded_projectspacing'>
                                    <h4 className='aboutus_fontbold'>Trainings</h4>
                                    <p>
                                        <strong>Create a Better version of yourself by being a part of the training and knowledge sharing we offer!
                                        </strong>
                                    </p>
                                    <div className='it_buttonalign'>
                                    <Link to='/training' class="cta" style={{ textDecoration: 'none' }}>
                                    <span>Training</span>
                                    <svg width="13px" height="10px" viewBox="0 0 13 10">
                                    <path d="M1,5 L11,5"></path>
                                    <polyline points="8 1 12 5 8 9"></polyline>
                                    </svg>
                                    </Link>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <hr/>
                </div>
                <br/>

                <div className='aboutus_mainspace'>
                    <h4  data-aos="fade-right">
                        <span className='aboutus_fontbold'>Success </span>
                        <span>Stories </span>
                        <Link to="/success-story">
                        <Plus class="rounded mx-auto homepage_plussize" />
                        </Link>
                    </h4>
                    <br/>
                    <div>
                        <Carousel
                        autoPlay={true}
                        responsive={responsive}
                        infinite={true}
                        autoPlaySpeed={3500}>
                            <Row>
                                <div className='embedded_contentspacing' >
                                    <p className='aboutus_textalign' >
                                        <strong  className='aboutus_fontbold'>
                                            Wireless Motors Control
                                        </strong>
                                    </p>
                                    <Row data-aos="fade-up" data-aos-duration="3000">
                                        <Col sm={6}>
                                            <Link to="/success-story">
                                                <Image src={WirelessMotor} alt='Wireless Motor Controller Hardware'  className='center' />
                                            </Link>
                                        </Col>

                                        <Col>
                                            <div className='embedded_contentspacing' >
                                                <br/>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong>
                                                        RF-based wireless Joystick and switch control to operate various
                                                        power motors for the areca tree climbing robot for the agriculture
                                                        automation<br/>
                                                    </strong>
                                                </p>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong className='it_ssnamesize aboutus_fontbold'>
                                                        <span className='it_ssnamecolor' > Gowrav Bhargav K R,</span><br/>
                                                        Sri Gowri Bhargava Private Limited, <br/>Koppa
                                                    </strong>
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Row>

                            <Row>
                                <div id='SS22' className='embedded_contentspacing' >
                                    <p className='aboutus_textalign'>
                                        <strong className='aboutus_fontbold'>
                                            Oil Blending Hardware
                                        </strong>
                                    </p>
                                    <Row data-aos="fade-up" data-aos-duration="3000">
                                        <Col sm={6}>
                                            <Link to="/success-story">
                                                <Image src={OilBlending} alt='Oil Blending controller Hardware' className='center embedded_ssimage' />
                                            </Link>
                                        </Col>

                                        <Col>
                                            <div className='embedded_contentspacing' >
                                                <br/>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong>
                                                        Relay based, Temperature controlled IoT circuit board design
                                                        for Oil blending Machine in organic soap manufacturing unit.<br/>
                                                    </strong>
                                                </p>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong className='it_ssnamesize aboutus_fontbold'>
                                                        <span className='it_ssnamecolor' >Narendra,</span><br/> COSMOS Ventures,<br/>Bengaluru
                                                    </strong>
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Row>


                            <Row>
                                <div className='embedded_contentspacing' >
                                    <p className='aboutus_textalign'>
                                        <strong className='aboutus_fontbold'>
                                            Time Logger
                                        </strong>
                                    </p>
                                    <Row data-aos="fade-up" data-aos-duration="3000">
                                        <Col sm={6}>
                                            <Link to="/success-story">
                                                <Image src={TimeLogger} alt='IoT based Time logger' className='center embedded_ssimage' />
                                            </Link>
                                        </Col>

                                        <Col>
                                            <div className='embedded_contentspacing' >
                                                <br/>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong>
                                                        480 Sec procedure time logger for foundries. Start time and end
                                                        time with the remaining time will be sent wirelessly to the software
                                                        and used for further production management and data analytics<br/>
                                                    </strong>
                                                </p>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong className='it_ssnamesize aboutus_fontbold'>
                                                        <span className='it_ssnamecolor' >Sharath,</span><br/> Techno Rings,<br/>Shivamogga
                                                    </strong>
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Row>

                            {/* <Row>
                                <div className='embedded_contentspacing' >
                                    <p className='aboutus_textalign'>
                                        <strong className='aboutus_fontbold'>
                                            Biometric Lock
                                        </strong>
                                    </p>
                                    <Row data-aos="fade-up" data-aos-duration="3000">
                                        <Col sm={6}>
                                            <Link to="/success-story">
                                                <Image src={FingerPrinting} alt='Biometric Lock' className='center embedded_ssimage' />
                                            </Link>
                                        </Col>

                                        <Col>
                                            <div className='embedded_contentspacing' >
                                                <br/>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong>
                                                        A fingerprint-based lock system will be placed in the bag and it will
                                                        be opened only by the biometric access of the authorized person.<br/>
                                                </strong>
                                                </p>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong className='it_ssnamesize aboutus_fontbold'>
                                                        <span className='it_ssnamecolor' >Achyuth,</span><br/>Mercedes Benz,<br/>Bengaluru
                                                    </strong>
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Row> */}

                            {/* <Row>
                                <div className='embedded_contentspacing' >
                                    <p className='aboutus_textalign'>
                                        <strong className='aboutus_fontbold'>
                                            Power Supply Timer
                                        </strong>
                                    </p>
                                    <Row data-aos="fade-up" data-aos-duration="3000">
                                        <Col sm={6}>
                                            <Link to="/success-story">
                                                <Image src={PST} alt='Power supply timer' className='center embedded_ssimagepst' />
                                            </Link>
                                        </Col>

                                        <Col>
                                            <div className='embedded_contentspacing' >
                                                <br/>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong>
                                                        The power supply adapter will have an adjustable knob and select
                                                        switches to set the timer and depending on that power supply will
                                                        be cut off to the load once the timer reaches the target time.<br/>
                                                    </strong>
                                                </p>
                                                <p className='it_sidecontentfontsize' >
                                                    <strong className='it_ssnamesize aboutus_fontbold'>
                                                        <span className='it_ssnamecolor' >Rakesh,</span><br/> Nano Source Technology,<br/>Bengaluru
                                                    </strong>
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Row> */}
                        </Carousel>
                    </div>
                    <br/>
                </div>
            </div>
            {/*Success Modal */}
                  <Modal
                  show={this.state.modal_success} backdrop='static'
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  className="modal_alert">
                  <Modal.Body className="modalBody">
                  <div className="aboutus_textalign">
                  <img src={successImage} width="8%"  alt="ekathvainnovations.com"></img>
                  <br/>
                  <br/>
                  <h4 className="aboutus_textalign"><strong> Success! </strong></h4>
                  <br/>
                  <br/>
                  <h6 className="aboutus_textalign">{this.state.message}</h6>
                  <br/>
                  <Button type="button" variant="outline-danger" onClick={this.toggle('success')}>OK</Button>
                  </div>
                  <br/>
                    </Modal.Body>
                  </Modal>

                  {/*Failure Modal */}
                  <Modal
                  show={this.state.modal_failure} backdrop='static'
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  className="modal_alert">
                  <Modal.Body className="modalBody">
                  <div className="aboutus_textalign">
                  <img src={failureImage} width="8%"  alt="ekathvainnovations.com"></img>
                  <br/>
                  <br/>
                  <h4 className="aboutus_textalign"><strong> Failure! </strong></h4>
                  <br/>
                  <br/>
                  <h6 className="aboutus_textalign">{this.state.message}</h6>
                  <br/>
                  <Button type="button" variant="outline-danger" onClick={this.toggle('failure')}>OK</Button>
                  </div>
                  <br/>
                </Modal.Body>
                  </Modal>


            <Footer/>
        </div>
      )
    }

}
export default EmbeddedServicePage;
